import * as React from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { TagEditorContext } from 'app/pages/TagEditor/TagEditor';
import { withStyles } from '@material-ui/core/styles';

enum UIComponetKey {
    value = 'value',
}

enum PropertyKey {
    name = 'ctaName',
}

const CssTextField = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            background: '#fff',
        },
    },
})(TextField);

const CtaNameBox: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const { markerUpdater, currentMarker: propertyData } = useContext(TagEditorContext);
    const maxNameLength: number = 15;

    const handleChange = (propertykey: PropertyKey, key: UIComponetKey) => {
        return function (event, newValue?) {
            markerUpdater.call({ ...propertyData, [propertykey]: newValue || event.target[key] });
        };
    };

    return (
        <div className="TitlePropertyBox">
            <div className="BoxTitle">{t('propertyText.ctaButtonText') + ' :'}</div>
            <CssTextField
                id="ctaName"
                placeholder={t('propertyText.ctaButtonText')}
                onChange={handleChange(PropertyKey.name, UIComponetKey.value)}
                inputProps={{ maxLength: maxNameLength }}
                variant="outlined"
                size="small"
                value={propertyData.ctaName ?? ''}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {(propertyData.ctaName?.length ?? '0') + '/' + maxNameLength}
                        </InputAdornment>
                    ),
                }}
            />
            <span className="HelperHint">{t('propertyText.ctaButtonTextHint')}</span>
        </div>
    );
};

export default CtaNameBox;
